module.exports = __webpack_public_path__ + "static/assets/0e91d4a5556679266b5a51b659b0e6a2.svg";